<template>
    <header class="krvshtyz_com df">
        <!-- 网站名称 -->
        <div class="krzobwei jcc aic dif h fdr fls">
            <img class="logo" src="https://digitalgcp.oss-cn-hangzhou.aliyuncs.com/static/home/index/logo.png" />
            <router-link to="/">
                <div>{{ $t("ks00rrah") }}</div>
                <div class="mt2">
                    {{ $t("ktvfb0nf") }}
                </div>
            </router-link>
        </div>
        <div class="df jcsb flg wsnw" v-if="show">
            <!-- 导航 -->
            <el-menu
                :default-active="activeIndex"
                class="el-menu-nav"
                mode="horizontal"
                :router="true"             
            >
                <template v-for="(item, index) in navs">
                    <!-- 含有二级菜单 -->
                    <el-submenu
                        v-if="item.children" 
                        :index="item.active" 
                        :key="index"                       
                    >
                        <template slot="title">{{ item.text }}
                            <span v-if="item.link=='/experiment'">({{ experiment_from }})</span>
                            <span v-else-if="item.link=='/cro'">({{gys_from}})</span>
                            <span v-else-if="item.link=='/medicalguide'">({{other_from}})</span>
                            <span v-else-if="researcher_from && item.link=='/researcher'">({{researcher_from}})</span>
                        </template>
                        <template v-for="(v, k) in item.children">
                            <el-menu-item 
                                @click="handleNavClick(v)"
                                :index="v.active"
                                class="child-nav"
                                :route="v.link"
                                :key="k"
                            >
                                {{ v.text }}
                            </el-menu-item>
                        </template>
                    </el-submenu>
                    <!-- 只有一级菜单 -->
                    <el-menu-item 
                        v-else 
                        :index="item.active" 
                        :key="index" 
                        @click="handleNavClick(item)"
                        :route="item.link"
                    >
                        {{ item.text }}
                    </el-menu-item>
                </template>    
            </el-menu>

            <!-- 最右侧 -->
            <div class="df aic">
                <div class="kww0ots0">
                    <el-dropdown trigger="click" class="cp" :hide-on-click="false">
                        <span class="el-dropdown-link"> {{ $t("ixrw5h9p") }} </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item class="kx1ib4m4_item">
                                <el-descriptions class="lxwmdown" title="商务合作" :column="1" contentClassName="lxwm_content" labelClassName="lxwm_label">
                                    <el-descriptions-item label="经理">向芮玉</el-descriptions-item>
                                    <el-descriptions-item label="手机">133-7278-0965（微信同号）</el-descriptions-item>
                                    <el-descriptions-item label="邮箱">xry@wuxuwang.com</el-descriptions-item>
                                </el-descriptions>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="kww0ots0">                    
                    <el-dropdown @command="handleOperate">
                        <span class="el-dropdown-link">
                            {{ $t("vzq9z5xs") }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                                v-for="v in dropdown"
                                :key="v.value"
                                :command="v"
                                :divided="v.divided"
                                :disabled="(v.value === lang)?true:false"
                            >
                                {{ v.label }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
    name: "TopNav",
    data() {
        return {
            // 操作菜单
            dropdown:[
                {
                    id: 0,
                    type: 'topage',
                    label: this.$t("ks00wk0w"),
                    value: '/workbench',
                    divided: false,
                },
                {
                    id: 1,
                    type: 'lang',
                    label: "中文",
                    value: "zh-cn",
                    divided: true,
                },
                {
                    id: 2,
                    type: 'lang',
                    label: "English",
                    value: "en-us",
                    divided: false,
                },
                // {
                //     id: 3,
                //     type: 'showimg',
                //     label: "联系我们",
                //     value: "@/assets/img/kx1i8i5t.png",
                //     divided: true,
                // },
                {
                    id: 4,
                    type: 'logout',
                    label: this.$t("yqt5xooh"),
                    value: "logout",
                    divided: true,
                },
            ],
            show: true,
        };
    },
    computed: {
        ...mapState(["kslhow0s_search_list"]),
        ...mapGetters(["ksvdfgih_search_chart_array"]),
        ...mapState(['experiment_from','gys_from', 'other_from', 'researcher_from']),
        // 当前激活的导航
        activeIndex() {
            return this.$route.path.toLowerCase().split("/")[1]; 
        },
        // 导航
        navs() {
            return [
                {
                    text: this.$t("ks00vo6h"),
                    link: "/research_center",
                    active: "research_center"
                },
                {
                    text: this.$t("ks00we6n"),
                    link: "/researcher",
                    active: "researcher",
                    children: [
                        {
                            text: this.$t("c7r87613"),
                            link: "/researcher",
                            active: "researcher"
                        },
                        {
                            text: this.$t("mwaq85rg"),
                            link: "/researcher_risk",
                            active: "researcher_risk"
                        },
                    ]
                },
                {
                    text: this.$t("ks00wfzw"),
                    link: "/experiment",
                    active: "experiment",
                    children: [
                        {
                            text: this.$t("ks008cde"),
                            link: "/experiment",
                            active: "experiment"
                        },
                        {
                            text: this.$t("ks008ctr"),
                            link: "/chictr",
                            active: "chictr"
                        },
                        {
                            text: this.$t("ugyz099y"),
                            link: "/linchuangus",
                            active: "linchuangus"
                        },
                        {
                            text: this.$t("ugyzcris"),
                            link: "/linchuangkr",
                            active: "linchuangkr"
                        },
                        {
                            text: this.$t("ugyzjprn"),
                            link: "/linchuangjp",
                            active: "linchuangjp"
                        },
                        {
                            text: this.$t("uzanzctr"),
                            link: "/linchuangau",
                            active: "linchuangau"
                        },
                    ]
                },
                {
                    text: this.$t("ks00wi2f"),
                    link: "/sponsor",
                    active: "sponsor"
                },
                {
                    text: this.$t("ks009gys"),
                    link: "/cro",
                    active: "cro",
                    children: [
                        {
                            text: this.$t("ks009cro"),
                            link: "/cro",
                            active: "cro"
                        },
                        {
                            text: this.$t("ks009sys"),
                            link: "/lab",
                            active: "lab"
                        },
                        // 隐藏SMO导航
                        // {
                        //     text: this.$t("ks009smo"),
                        //     link: "/smo",
                        //     active: "smo"
                        // },
                        {
                            text: this.$t("ks9other"),
                            link: "/supplier",
                            active: "supplier"
                        },
                    ]
                },
                {
                    text: this.$t("ks0other"),
                    link: "/medicalguide",
                    active: "medicalguide",
                    children: [
                        {
                            text: this.$t("ks0guide"),
                            link: "/medicalguide",
                            active: "medicalguide"
                        },
                        {
                            text: this.$t("ks00zdyz"),
                            link: "/guideprinciple",
                            active: "guideprinciple"
                        },
                    ]
                },
                {
                    text: '决策分析',
                    link: "/strategic",
                    active: "strategic"
                },
                // {
                //     text: this.$t("ks00rprt"),
                //     link: "/report",
                //     active: "report"
                // },
            ];
        },
    },
    watch:{
        "$route"(){
            this.nownavfrom();
            this.show = false;
            this.$nextTick(()=>{
                this.show = true;
            })
        }
    },
    created(){
        // 任务页面 - 初始化导航中括号的值
        this.init_from()
        // 对应列表详情-初始化导航中括号的值
        this.nownavfrom();
    },
    methods: {
        init_from(){
            this.$store.dispatch('experiment_from', this.$t('ks008cde'));
            this.$store.dispatch('gys_from', this.$t('ks111cro'));
            this.$store.dispatch('other_from', this.$t('ks0guide'));
        },
        async handleNavClick(e) {
            // 场景：CMO之类的库无图表、地图的模块详情/工作台刷新->点击导航：路由本应该只是列表路由，如果当前路由是详情时，不继续操作
            if (
                typeof(this.$route.name)=='undefined' || 
                this.$route.name.indexOf('Detail') != -1 || 
                this.$route.name.indexOf('Workbench') != -1
            ) {
                return;
            }
            // 重置
            await this.$store.commit("ksmwccyb_active_index_reset");
            await this.$store.commit("ks1hfc6b_condition_reset");
            await this.$store.commit("ksk9lzmn_value_tree_reset");

            await this.$store.commit("ksk6p8gl_search_condition_reset");
            await this.$store.commit("kslhow0s_search_list_reset");
            await this.$store.commit("kstpyoet_chart_condition_reset");
            await this.$store.commit("ksv4vnl8_result_active_index_reset");
            await this.$store.commit("ksvdfgih_search_chart_reset");

            await this.$nextTick(() => {
                // 工作台不用请求列表等数据
                if (e.link=='/workbench') {
                    return;
                }
                // 搜索-条件
                this.$store.dispatch("ks1hfc6b_condition");

                // 试验-对表格进行一次排序
                if (this.$route.name.toLowerCase() === "experiment") {
                    Object.assign(this.$store.state.kslhow0s_search_list.qs, {
                        sort: "date_public",
                        order: "desc",
                    });
                } else {
                    delete this.$store.state.kslhow0s_search_list.qs.sort;
                    delete this.$store.state.kslhow0s_search_list.qs.order;
                }
                // 搜索列表
                this.$store.dispatch("kslhow0s_search_list");
                // 搜索图表
                this.$store.dispatch("kstpyoet_chart_condition");
                // 搜索地图
                this.$store.dispatch("ktwc1c5g_search_map_data");
            });
        },
        // 语言选择
        handleSelectLang(node) {
            this.$cookie.set("lang", node.value);
            location.reload();
        },
        handleOperate(node) {
            console.log(node)
            switch (node.type) {
                case "topage":
                    this.$router.push({path: node.value });
                    break;
                case "lang":
                    this.$cookie.set("lang", node.value);
                    location.reload();
                    break;
                case "logout":
                    this.$common.towuxu('logout');
                    break;
            }
        },
        // 检测当前导航-试验：是在CTR还是CHI、供应商：是在CRO还是在第三方实验室
        nownavfrom(){
            if(this.$route.name=='researcher' || this.$route.name=='researcherDetail'){
                this.$store.dispatch('researcher_from', '');
            }else if(this.$route.name=='researcher_risk' || this.$route.name=='researcherriskDetail'){
                this.$store.dispatch('researcher_from', this.$t('mwaq85rg'));
            }
            if(this.$route.name=='chictr' || this.$route.name=='ChictrDetail'){
                this.$store.dispatch('experiment_from', this.$t('ks008ctr'));
            }else if(this.$route.name=='experiment'){
                this.$store.dispatch('experiment_from', this.$t('ks008cde'));
            }else if(this.$route.name=='linchuangus' || this.$route.name=='linchuangusDetail'){
                this.$store.dispatch('experiment_from', this.$t('ugyz099y'));
            }else if(this.$route.name=='linchuangkr' || this.$route.name=='linchuangkrDetail'){
                this.$store.dispatch('experiment_from', this.$t('ugyzcris'));
            }else if(this.$route.name=='linchuangjp' || this.$route.name=='linchuangjpDetail'){
                this.$store.dispatch('experiment_from', this.$t('ugyzjprn'));
            }else if(this.$route.name=='linchuangau' || this.$route.name=='linchuangauDetail'){
                this.$store.dispatch('experiment_from', this.$t('uzanzctr'));
            }
            if(this.$route.name=='lab' || this.$route.name=='LabDetail'){
                this.$store.dispatch('gys_from', this.$t('ks111sys'));
            }else if(this.$route.name=='cro'){
                this.$store.dispatch('gys_from', this.$t('ks111cro'));
            }else if(this.$route.name=='smo' || this.$route.name=='SmoDetail'){
                this.$store.dispatch('gys_from', this.$t('ks009smo'));
            }else if(this.$route.name=='supplier' || this.$route.name=='SupplierDetail'){
                this.$store.dispatch('gys_from', this.$t('ks9other'));
            }
            if(this.$route.name=='medicalguide' || this.$route.name=='MedicalGuideDetail'){
                this.$store.dispatch('other_from', this.$t('ks0guide'));
            }else if(this.$route.name=='guideprinciple' || this.$route.name=='GuidePrincipleDetail'){
                this.$store.dispatch('other_from', this.$t('ks00zdyz'));
            }
        },
    },
};
</script>

<style lang="less">
@import (reference) "@/assets/less/base.less";
@comHeight: 60px;

.krvshtyz_com {
    .ps;
    .w;
    top: 0;
    height: @comHeight;
    background: @c_theme;
    color: #fff;
    z-index: 2002;
    min-width: 1280px;
    a {
        color: inherit;
    }
}
.krzobwei {
    width: 246px;
    .logo {
        width: 70px;
        margin-right: 8px;
    }
}

.krzqo2fs_svg {
    svg {
        .c_white;
    }
}
.krzrkn3x {
    .lhn;
    padding: 13px 0;
}
.kww0ots0 {
    &:last-child {
        .mr20;
    }
    + .kww0ots0 {
        .ml20;
    }
    // reset elementui
    .el-dropdown {
        color: #fff;
    }
}
.lc-logout{
    width: 98px;
}
#body .kx1ib4m4_item {
    &:hover {
        color: transparent;
        background: currentColor;
    }
}
// 导航插件样式调整
.el-menu-nav{
    border: none !important;
    background-color: @c_theme !important;
    .el-menu-item,.el-submenu__title,.el-icon-arrow-down{
        border: none !important;
        color: #FFF !important;
    }
    .is-active{
        background: #FFF !important;
        color: @c_theme !important; 
        .el-submenu__title,.el-icon-arrow-down{
            color: @c_theme !important;  
        }
    }
    .el-menu-item:hover,.el-submenu__title:hover{
        color: @c_theme !important;
        .el-submenu__title,.el-icon-arrow-down{
            color: @c_theme !important;  
        }
    }
}
.child-nav:hover{
    color: @c_theme !important;
}
.lxwmdown{
    width: 300px;
    .lxwm_label{
        font-size: 16px;
        color: @c_theme;
    }
    .lxwm_content{
        font-size: 16px;
    }
}
</style>
